import { render, staticRenderFns } from "./SettingTemplateDialog.vue?vue&type=template&id=70040f34&scoped=true&"
import script from "./SettingTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./SettingTemplateDialog.vue?vue&type=script&lang=js&"
import style0 from "./SettingTemplateDialog.vue?vue&type=style&index=0&id=70040f34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70040f34",
  null
  
)

export default component.exports